import toSnakeCase from 'to-snake-case'

import { ACORNS_HELLO_FLOW, APP_VERSION } from 'app-constants'
import { getDefaultFlow, getFunnelName } from 'utils/FlowProvider/utils'

import platform from './platform'

export default (event: string) => ({
  app_version: APP_VERSION,
  event_text: event,
  event: toSnakeCase(event),
  platform,
  funnel: getFunnelName(window.localStorage.getItem(ACORNS_HELLO_FLOW)) || getDefaultFlow(),
})
